import { render, staticRenderFns } from "./Onboarding.vue?vue&type=template&id=5d1a07eb&"
import script from "./Onboarding.vue?vue&type=script&lang=ts&"
export * from "./Onboarding.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports